import React from "react";

class Maintenance extends React.Component {
    componentDidMount() {
        document.title = "Maintenance - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
    }
    render() {
        return <div className="pboutique">
            <h2 className="pboutique__ttl">Le site est actuellement en maintenance, veuillez revenir dans quelques jours.</h2>
        </div>
    }
}

export default Maintenance;